import { Component, HostBinding, Input } from '@angular/core';
import { ComponentWithSizesComponent } from '@vendasta/galaxy/utility/component-with-sizes';

@Component({
  selector: 'glxy-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
})
export class ProgressBarComponent extends ComponentWithSizesComponent {
  // Progress is a number from 0-100 indicating the progress as a percentage
  @Input() progress = 0;

  // Color scheme ('primary', 'warn', 'error', 'success')
  @Input() color = 'primary';

  @HostBinding('style.height.px')
  get padding(): number {
    switch (this.size) {
      case 'large':
        return 16;
      case 'small':
        return 8;
      default:
        return 12;
    }
  }
}
